import {
    Map,
    ClipboardList,
    BarChart3,
    CheckCircle,
    AlertTriangle
} from 'lucide-react';

export const manualModules = [
    {
        id: 'map',
        titleKey: 'manualsData.map.title',
        descriptionKey: 'manualsData.map.description',
        icon: Map,
        targetRoles: ['OPERADOR', 'SUPERVISOR', 'COORDINADOR'],
        sections: [
            {
                titleKey: 'manualsData.map.sections.navigation.title',
                contentKey: 'manualsData.map.sections.navigation.content',
                tipKey: 'manualsData.map.sections.navigation.tip',
                steps: [
                    { titleKey: 'manualsData.map.sections.navigation.steps.zoom.title', descriptionKey: 'manualsData.map.sections.navigation.steps.zoom.description' },
                    { titleKey: 'manualsData.map.sections.navigation.steps.layers.title', descriptionKey: 'manualsData.map.sections.navigation.steps.layers.description' },
                    { titleKey: 'manualsData.map.sections.navigation.steps.filters.title', descriptionKey: 'manualsData.map.sections.navigation.steps.filters.description' }
                ]
            },
            {
                titleKey: 'manualsData.map.sections.drawing.title',
                contentKey: 'manualsData.map.sections.drawing.content',
                warningKey: 'manualsData.map.sections.drawing.warning',
                steps: [
                    { titleKey: 'manualsData.map.sections.drawing.steps.area.title', descriptionKey: 'manualsData.map.sections.drawing.steps.area.description' },
                    { titleKey: 'manualsData.map.sections.drawing.steps.markers.title', descriptionKey: 'manualsData.map.sections.drawing.steps.markers.description' },
                    { titleKey: 'manualsData.map.sections.drawing.steps.editing.title', descriptionKey: 'manualsData.map.sections.drawing.steps.editing.description' }
                ]
            }
        ]
    },
    {
        id: 'operations',
        titleKey: 'manualsData.operations.title',
        descriptionKey: 'manualsData.operations.description',
        icon: ClipboardList,
        targetRoles: ['COORDINADOR', 'ADMINISTRADOR'],
        sections: [
            {
                titleKey: 'manualsData.operations.sections.create.title',
                contentKey: 'manualsData.operations.sections.create.content',
                tipKey: 'manualsData.operations.sections.create.tip',
                steps: [
                    { titleKey: 'manualsData.operations.sections.create.steps.general.title', descriptionKey: 'manualsData.operations.sections.create.steps.general.description' },
                    { titleKey: 'manualsData.operations.sections.create.steps.georeference.title', descriptionKey: 'manualsData.operations.sections.create.steps.georeference.description' },
                    { titleKey: 'manualsData.operations.sections.create.steps.commander.title', descriptionKey: 'manualsData.operations.sections.create.steps.commander.description' }
                ]
            },
            {
                titleKey: 'manualsData.operations.sections.states.title',
                contentKey: 'manualsData.operations.sections.states.content',
                steps: [
                    { titleKey: 'manualsData.operations.sections.states.steps.active.title', descriptionKey: 'manualsData.operations.sections.states.steps.active.description' },
                    { titleKey: 'manualsData.operations.sections.states.steps.completed.title', descriptionKey: 'manualsData.operations.sections.states.steps.completed.description' }
                ]
            }
        ]
    },
    {
        id: 'evaluation',
        titleKey: 'manualsData.evaluation.title',
        descriptionKey: 'manualsData.evaluation.description',
        icon: CheckCircle,
        targetRoles: ['SUPERVISOR', 'COORDINADOR'],
        sections: [
            {
                titleKey: 'manualsData.evaluation.sections.concept.title',
                contentKey: 'manualsData.evaluation.sections.concept.content',
                steps: [
                    { titleKey: 'manualsData.evaluation.sections.concept.steps.level1.title', descriptionKey: 'manualsData.evaluation.sections.concept.steps.level1.description' },
                    { titleKey: 'manualsData.evaluation.sections.concept.steps.level2.title', descriptionKey: 'manualsData.evaluation.sections.concept.steps.level2.description' },
                    { titleKey: 'manualsData.evaluation.sections.concept.steps.level3.title', descriptionKey: 'manualsData.evaluation.sections.concept.steps.level3.description' }
                ]
            },
            {
                titleKey: 'manualsData.evaluation.sections.process.title',
                contentKey: 'manualsData.evaluation.sections.process.content',
                warningKey: 'manualsData.evaluation.sections.process.warning',
                steps: [
                    { titleKey: 'manualsData.evaluation.sections.process.steps.access.title', descriptionKey: 'manualsData.evaluation.sections.process.steps.access.description' },
                    { titleKey: 'manualsData.evaluation.sections.process.steps.questionnaire.title', descriptionKey: 'manualsData.evaluation.sections.process.steps.questionnaire.description' },
                    { titleKey: 'manualsData.evaluation.sections.process.steps.result.title', descriptionKey: 'manualsData.evaluation.sections.process.steps.result.description' }
                ]
            }
        ]
    },
    {
        id: 'reports',
        titleKey: 'manualsData.reports.title',
        descriptionKey: 'manualsData.reports.description',
        icon: BarChart3,
        targetRoles: ['ADMINISTRADOR', 'COORDINADOR'],
        sections: [
            {
                titleKey: 'manualsData.reports.sections.available.title',
                contentKey: 'manualsData.reports.sections.available.content',
                steps: [
                    { titleKey: 'manualsData.reports.sections.available.steps.operationSheet.title', descriptionKey: 'manualsData.reports.sections.available.steps.operationSheet.description' },
                    { titleKey: 'manualsData.reports.sections.available.steps.lists.title', descriptionKey: 'manualsData.reports.sections.available.steps.lists.description' }
                ]
            },
            {
                titleKey: 'manualsData.reports.sections.formats.title',
                contentKey: 'manualsData.reports.sections.formats.content',
                steps: [
                    { titleKey: 'manualsData.reports.sections.formats.steps.pdf.title', descriptionKey: 'manualsData.reports.sections.formats.steps.pdf.description' }
                ]
            }
        ]
    },
    {
        id: 'critical_nodes',
        titleKey: 'manualsData.criticalNodes.title',
        descriptionKey: 'manualsData.criticalNodes.description',
        icon: AlertTriangle,
        targetRoles: ['OPERADOR', 'SUPERVISOR'],
        sections: [
            {
                titleKey: 'manualsData.criticalNodes.sections.detection.title',
                contentKey: 'manualsData.criticalNodes.sections.detection.content',
                steps: [
                    { titleKey: 'manualsData.criticalNodes.sections.detection.steps.autoAlert.title', descriptionKey: 'manualsData.criticalNodes.sections.detection.steps.autoAlert.description' },
                    { titleKey: 'manualsData.criticalNodes.sections.detection.steps.conflictInfo.title', descriptionKey: 'manualsData.criticalNodes.sections.detection.steps.conflictInfo.description' }
                ]
            },
            {
                titleKey: 'manualsData.criticalNodes.sections.resolution.title',
                contentKey: 'manualsData.criticalNodes.sections.resolution.content',
                steps: [
                    { titleKey: 'manualsData.criticalNodes.sections.resolution.steps.coordination.title', descriptionKey: 'manualsData.criticalNodes.sections.resolution.steps.coordination.description' },
                    { titleKey: 'manualsData.criticalNodes.sections.resolution.steps.adjustment.title', descriptionKey: 'manualsData.criticalNodes.sections.resolution.steps.adjustment.description' }
                ]
            }
        ]
    }
];
